export default __webpack_public_path__ + "static/media/crypto_icon.07612441.png";